module.exports = __webpack_public_path__ + "applemango/img/intro_cart04.8f33803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chart/intro_cart04.png
// module id = n6ej
// module chunks = 75